const initCtaTarget =  () => {
  document.addEventListener('click', (event) => {
        const openModalButton = event.target.closest('[data-open-modal]');

        if (openModalButton) {
            document.dispatchEvent(new CustomEvent('open-modal', { detail: { modalId: openModalButton.dataset.openModal } }));
        }
        
        const elementToClick = event.target.closest('[data-element-to-click]')?.dataset?.elementToClick;

        if (elementToClick) {
            const elementToClickSelector = new DOMParser().parseFromString(elementToClick, "text/html").documentElement.textContent;
            const initClick = elementToClick && document.querySelector(`${elementToClickSelector}`);
    
            if (initClick) {
                document.querySelector(`${elementToClickSelector}`).click();
            }
        }
    });
};

export { initCtaTarget };